module.exports = __webpack_public_path__ + "79acf569be1832a73d13db4c3cb69e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_2023_chart.png
// module id = 1682
// module chunks = 0